let $ = jQuery;

class FooterSearch {

  constructor() {
    this.$footerLocationSearch = $('#footer-location-search');
    this.$footerLocationSubmit = $('#footer-location-search-submit');
    this.setUpLocationSearch();
  }

  setUpLocationSearch() {
    this.$footerLocationSearch.on('keypress', (e) => this.handleLocationKeyPress(e));
    this.$footerLocationSubmit.on('click', (e) => this.handleLocationSearch(e));
  }

  handleLocationKeyPress(e) {
    if (e.which == 13) {//Enter key pressed
      this.handleLocationSearch(e);
    }
  }

  handleLocationSearch(e) {
    e.preventDefault();

    // Redirect to search results.

    var redirect_url = window.location.origin + '/search?content_type=Location';

    if (this.$footerLocationSearch.val() != "") {
      redirect_url += '&place=' + this.$footerLocationSearch.val();
    }

    window.location.href = redirect_url;
  }
}

module.exports = {
  attach: function (context, settings) {
    let footerSearch = new FooterSearch();
  }
}
